import { Card, CardContent, Typography, Stack, Box, alpha } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import LucideIcon from "../LucideIcon";

export default function KpiCard2({ title, value, subtitle, icon, action }) {
    return (
        <Card elevation={0} sx={{ height: "100%", borderRadius: '10px', bgcolor: '#f7f7f7a4', border: '1px solid gainsboro', boxShadow: 'none' }}>
            <CardContent>
                <Stack spacing={1.5} direction={'column'} alignItems={'start'}>

                    {icon && (
                        <Box padding={1.5} sx={{ borderRadius: '10px', bgcolor: alpha('#5E17EB', 0.08), color: '#5E17EB' }} direction="row" spacing={1} justifyContent="center" alignItems="center">
                            <LucideIcon name={icon} />
                        </Box>
                    )}

                    <Typography variant="h5" fontWeight="800">
                        {value}
                    </Typography>
                    <Stack sx={{ width:'100%'}} direction={'row'} justifyContent={'space-between'} >
                        <Typography fontSize={'16px'} color="text.secondary">
                            {title}
                        </Typography>
                        
                        {action && action}
                    </Stack>

                </Stack>
            </CardContent>
        </Card>
    );
}
